<template>
    <modal :name="vimCtnID" :clickToClose="false" width="100%" height="100%"
    @opened="openedHandler" @closed="$emit('closed')">
    <!-- @opened="openedHandler" @closed="$emit('closed')" @keyup.native.esc.exact.capture="hide"> -->
    
        <div class="editor-ctn">
            <div>Vim Mode</div>

            <codemirror ref="cm" :value="data" :options="cmOptions" 
            @ready="onCmReady" @focus="onCmFocus" @input="onCmCodeChange" 
            @vim-keypress="onVimCommandDone"
            class="code-mirror-customize" />

            <el-input id='command-display' v-model="keys" size="mini" class="command-display" />
        </div>
    </modal>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/keymap/vim'
import 'codemirror/theme/base16-dark.css'

let rawCodeMirror = require('codemirror')

// https://github.com/surmon-china/vue-codemirror
// https://codemirror.net/doc/manual.html

export default {
    name: "vimMode",
    props: ["tabID", "data"],
    components: { codemirror },
    data() {
        return {
            cmOptions: {
                mode: 'text/shell',
                theme: 'base16-dark',
                lineNumbers: true,
                // readOnly: true,
                keyMap: "vim",
            },

            keys: "kekeda",
        }
    },
    mounted() {
        // this.$refs.cm.on("vim-keypress", (key) => {
        //     console.log("vim mode key press key:", key)
        // } )
        // this.$refs.cm.codemirror
        
    },
    computed: {
        vimCtnID: function() {
            return this.tabID + '-vim-mode-ctn'
        },
    },
    methods: {
        show() {
            this.$modal.show(this.vimCtnID)
        },
        hide() {
            this.$modal.hide(this.vimCtnID)
        },
        openedHandler() {
            this.$refs.cm.codemirror.focus()
        },
        onCmReady() {
            console.log("cm ready")
            this.$refs.cm.codemirror.setSize("100%", "100%")
            this.$refs.cm.codemirror.execCommand("goDocEnd")     
            rawCodeMirror.on(this.$refs.cm.codemirror, 'vim-keypress', function(vimKey) {console.log("vim-keypress:", vimKey)})
            rawCodeMirror.on(this.$refs.cm.codemirror, 'vim-command-done', function(reason) {console.log("vim-command-done reason:", reason)})
            rawCodeMirror.on(this.$refs.cm.codemirror, 'vim-mode-change', function(modeObj) {console.log("vim-mode-change modeObj:", modeObj)})
        },
        onCmFocus() {
            console.log("cm focus")
        },
        onCmCodeChange() {
            console.log("cm code change")
        },
        onVimCommandDone() {
            console.log("onVimCommandDone")
        },
    },
}
</script>

<style scoped>
.editor-ctn {
    height: 100%;

    display: grid;
    grid-template-rows: 60px auto 28px;
}
.command-display {
    /* flex-grow: 0; */
   
}
.code-mirror-customize {
    text-align: left;
}

/deep/
.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {
    background-color: transparent;
}

/deep/
.CodeMirror {
    font-family: 'JetBrains Mono Thin';
}
</style>